import React, { useEffect } from 'react';
import { Platform } from 'react-native';
import NetInfo, { useNetInfo } from '@react-native-community/netinfo';
import { useReactiveVar } from '@apollo/client/react/hooks';
import { netWorkStatus } from '../../state/apolloVars';
import config from '../../config';

// Without this, on web netinfo falls back to its default reachability probe
// (HEAD "/" on the app's own origin). The Deno host serving kds.oolio.io answers
// 405 to HEAD, so isInternetReachable was permanently false -> a false "offline"
// icon. Probe an oolio health endpoint with GET instead, matching pos-app/cds-app.
NetInfo.configure({
  useNativeReachability: Platform.OS !== 'web',
  reachabilityUrl: config.HEALTH_CHECK_URL,
  reachabilityTest: async response => response.status === 200,
  reachabilityMethod: 'GET',
  reachabilityLongTimeout: 10 * 1000,
  reachabilityShortTimeout: 5 * 1000,
  reachabilityRequestTimeout: 5 * 1000,
});

export const useNetworkStatusVar = () => useReactiveVar(netWorkStatus);

const NetworkStatus = () => {
  const netInfo = useNetInfo();
  useEffect(() => {
    netWorkStatus(!!netInfo?.isConnected && !!netInfo?.isInternetReachable);
  }, [netInfo]);
  return <></>;
};

export default NetworkStatus;
